const ClassificationWorkbench = () => import(/* webpackChunkName: "configuration" */'@/components/pages/configuration/classification/Workbench');
const ClassificationDetail = () => import(/* webpackChunkName: "configuration" */'@/components/pages/configuration/classification/ClassificationDetail');
const Relation = () => import(/* webpackChunkName: "configuration" */'@/components/pages/configuration/relation/Relation');
const DispatchWorkbench = () => import(/* webpackChunkName: "configuration" */'@/components/pages/configuration/autoDispatch/Workbench');
const DispatchRuleOperate = () => import(/* webpackChunkName: "configuration" */'@/components/pages/configuration/autoDispatch/DispatchRuleOperate');

export default [
  {
    path: 'classification-bench',
    name: 'classificationBench',
    meta: {
      title: '分类属性配置',
      componentName: 'ClassificationWorkbench',
      roles: ['CLASS_ATTRIBUTE_QUERY'],
      breadcrumb: [
        {
          name: '分类属性配置',
          path: '/system/business/classification-bench'
        }
      ],
    },
    component: ClassificationWorkbench
  },
  {
    path: 'create-classification',
    name: 'createClassification',
    meta: {
      title: '新建分类',
      componentName: 'ClassificationDetail',
      hidden: true,
      activeMenu: '/system/business/classification-bench',
      roles: ['CLASS_ATTRIBUTE_ADD'],
      breadcrumb: [
        {
          name: '新建分类',
          path: '/system/business/create-classification'
        }
      ],
    },
    component: ClassificationDetail
  },
  {
    path: 'edit-classification/:id',
    name: 'editClassification',
    meta: {
      title: '编辑分类',
      componentName: 'ClassificationDetail',
      hidden: true,
      activeMenu: '/system/business/classification-bench',
      roles: ['CLASS_ATTRIBUTE_UPDATE'],
      breadcrumb: [
        {
          name: '编辑分类',
          path: '/system/business/edit-classification/:id'
        }
      ],
    },
    component: ClassificationDetail
  },
  {
    path: 'relation',
    name: 'relation',
    meta: {
      title: '关系类型配置',
      componentName: 'Relation',
      roles: ['RELATIONS_QUERY'],
      breadcrumb: [
        {
          name: '关系类型配置',
          path: '/system/business/relation'
        }
      ],
    },
    component: Relation
  },
  {
    path: 'dispatch-workbench',
    name: 'dispatchWorkbench',
    meta: {
      title: '事件自动分派',
      componentName: 'DispatchWorkbench',
      roles: ['WF_AUTO_DISPATCH_QUERY'],
      breadcrumb: [
        {
          name: '事件自动分派',
          path: '/system/business/dispatch-workbench'
        }
      ],
    },
    component: DispatchWorkbench
  },
  {
    path: 'create-dispatch-rule',
    name: 'createDispatchRule',
    meta: {
      title: '事件自动分派',
      componentName: 'DispatchRuleOperate',
      roles: ['WF_AUTO_DISPATCH_CREATE'],
      hidden: true,
      activeMenu: '/system/business/dispatch-workbench',
      breadcrumb: [
        {
          name: '新建自动分派规则',
          path: '/system/business/create-dispatch-rule'
        }
      ],
    },
    component: DispatchRuleOperate
  },
  {
    path: 'edit-dispatch-rule/:id',
    name: 'editDispatchRule',
    meta: {
      title: '事件自动分派',
      componentName: 'DispatchRuleOperate',
      roles: ['WF_AUTO_DISPATCH_UPDATE'],
      hidden: true,
      activeMenu: '/system/business/dispatch-workbench',
      breadcrumb: [
        {
          name: '编辑自动分派规则',
          path: '/system/business/edit-dispatch-rule/:id'
        }
      ],
    },
    component: DispatchRuleOperate
  },
];


// WEBPACK FOOTER //
// ./src/router/configuration.js